/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

import Vue from "vue"
import Vuex from "vuex"
import registration from "./modules/registration"
import ecuserinfo from "./modules/ecuserinfo"
import util from "./modules/util"
import notification from "./modules/notification"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    registration,
    ecuserinfo,
    util,
    notification
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js